import React, { FC, ReactNode, memo } from 'react';
import { useTranslator } from '@nice-ccf/ui-controls';
import { Box } from '@mui/material';
import { editorPlaceholderStyles } from './ccf-editor-placeholder.styles';

/**
 * Component displays Editor placeholder while ACP generate response
 * @returns Editor Placeholder
 * ```
 * @example
 * <EditorPlaceholder placeholderLoadingIcon={<div>placeholderLoadingIcon</div>} loadingText="reply is generating..."/>
 * ```
 */
const EditorPlaceholder: FC<{ placeholderLoadingIcon?: ReactNode; loadingText?: string }> = ({
  placeholderLoadingIcon,
  loadingText,
}) => {
  const styles = editorPlaceholderStyles();
  const [translate] = useTranslator();
  const translatedText = loadingText || translate('copilotEmailGenerationPlaceholderText');

  return (
    <Box style={styles.wrap}>
      {placeholderLoadingIcon && placeholderLoadingIcon}
      <Box style={styles.text}>{translatedText} </Box>
    </Box>
  );
};

export default memo(EditorPlaceholder);